import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';
import StatusBadge from '../components/shared/StatusBadge';

export default function Shipping() {
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    Promise.all([
      api.get('/orders?status_filter=CONFIRMED'),
      api.get('/orders?status_filter=PACKED'),
      api.get('/orders?status_filter=SHIPPED'),
    ]).then(([a, b, c]) => setOrders([...a.data.items, ...b.data.items, ...c.data.items]));
  }, []);

  return (
    <div className="space-y-5 fade-up">
      <div className="fab-card overflow-hidden">
        <table className="w-full text-[13px]">
          <thead>
            <tr className="text-[10px] text-fab-text-muted uppercase tracking-wider bg-fab-elevated">
              <th className="text-left px-4 py-3 font-semibold">Order</th>
              <th className="text-left px-4 py-3 font-semibold">Buyer</th>
              <th className="text-left px-4 py-3 font-semibold">Courier</th>
              <th className="text-left px-4 py-3 font-semibold">Tracking</th>
              <th className="text-left px-4 py-3 font-semibold">Status</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-b border-fab-primary-lighter last:border-0 hover:bg-fab-elevated">
                <td className="px-4 py-3"><Link to={`/dashboard/orders/${o.id}`} className="text-fab-primary font-semibold font-mono">{o.order_number}</Link></td>
                <td className="px-4 py-3 text-fab-text">{o.buyer_name}</td>
                <td className="px-4 py-3 text-fab-text-secondary">{o.shipment?.courier_name || '—'}</td>
                <td className="px-4 py-3 font-mono text-fab-primary text-[12px]">{o.shipment?.tracking_id || '—'}</td>
                <td className="px-4 py-3"><StatusBadge status={o.status} size="sm" /></td>
              </tr>
            ))}
            {orders.length === 0 && <tr><td colSpan="5" className="text-center text-fab-text-muted py-10">No shipments in pipeline.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
